import {FieldConfig, FieldDataTypes, NameableInterface, nNumber, nString, uNumber, Uuid} from "@hidat/huijs-common";
import {RblFieldConfigs, RblNestResourceInterface} from "../rbl-resource.interface";
import {BrandedResource, BrandedResourceFields} from "./branded-resource.interface";
import {LocalDate} from "@js-joda/core";
import {ResourceConfig} from "@hidat/huijs-resource";

export const PlaylistLogConfig = new ResourceConfig('PlaylistLog', 'playlist_logs')
  .addFields(BrandedResourceFields)
  .addFields([
    new FieldConfig('priority', FieldDataTypes.INTEGER),
    new FieldConfig('playlistPageId', FieldDataTypes.UID),
    new FieldConfig('startsAt', FieldDataTypes.DATE),
    new FieldConfig('endsAt', FieldDataTypes.DATE),
    RblFieldConfigs.library
  ])

export interface PlaylistLogInterface extends RblNestResourceInterface, NameableInterface, BrandedResource {

  playlistPageId: Uuid | undefined;
  startsAt: LocalDate | undefined | null;
  endsAt: LocalDate | undefined | null;

  priority: uNumber;
  binId: uNumber;
  libraryId: nNumber;
  listId: nNumber;
}
